<template>
    <b-card title="" class="trigger-card p-2 mb-2" no-body>
        <b-card-body class="p-2">
            <b-row class="flex-md-row flex-column">
                <b-col md="5" class="mb-2 mb-md-0">
                    <validation-provider
                        
                        rules="required"
                        v-slot="{ errors, handleChange }"
                        name="title"
                        :value="title"
                    >
                        <form-input
                            label="Trigger Title"
                            :labelClass="['text-primary', 'font-weight-bold']"
                            placeholder="Trigger Title"
                            class="mb-md-0 title-input"
                            :value="title"
                            @input="
                                (val) => {
                                    handleChange(val);
                                    onChangeTitle(val);
                                }
                            "
                            :error="errors[0]"
                            :disabled="readonly"
                        />
                    </validation-provider>
                </b-col>
                <b-col md="5" class="mb-2 mb-md-0">
                    <form-dropdown
                        label="Copy from another Trigger"
                        :labelClass="['text-primary', 'font-weight-bold']"
                        placeholder="Select one"
                        class="mb-md-0"
                        :options="filteredTriggerOptions"
                        :value="selectedTriggerForCopy"
                        @input="onChangeCopyTrigger"
                        :disabled="readonly"
                    />
                </b-col>
                <b-col md="1" class="mb-2 mb-md-0">
                    <span class="d-block mb-2 text-primary text-nowrap"><b>Active</b></span>
                    <form-switch
                        class="active-switch"
                        color="#0d47a1"
                        labels=""
                        :value="isEnabled"
                        @input="onChangeEnabled"
                        :sync="true"
                    />
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
    import FormInput from '../../../generic/form-input/form-input.vue';
    import FormDropdown from '../../../generic/form-dropdown/form-dropdown.vue';
    import FormSwitch from '../../../generic/form-switch/form-switch.vue';

    import { mapGetters } from 'vuex';
    export default {
        components: {
            FormInput,
            FormDropdown,
            FormSwitch,
        },
        inject: ['triggerId', 'setFormValues'],
        computed: {
            ...mapGetters('trigger', ['title', 'isEnabled', 'triggerOptions', 'selectedTriggerForCopy', 'readonly']),
            filteredTriggerOptions() {
                return this.triggerOptions.filter((item) => item.value !== this.triggerId);
            },
        },
        methods: {
            onChangeEnabled(value) {
                this.$store.commit('trigger/setEnabled', value);
                this.$store.commit('trigger/setEditing', true);
            },
            onChangeTitle(value) {
                this.$store.commit('trigger/setTitle', value);
                this.$store.commit('trigger/setEditing', true);
            },
            async onChangeCopyTrigger(value) {
                try {
                    this.$emit('busy', true);
                    const triggerData = await this.$store.dispatch('trigger/copyTrigger', {
                        triggerId: value,
                    });
                    this.setFormValues(triggerData);
                    this.$emit('busy', false);
                } catch (e) {
                    this.errorToast({ text: 'Could not copy trigger' });
                }
            },
        },
    };
</script>

<style>
    @import '../styles.scss';
</style>
